// removed by extract-text-webpack-plugin
module.exports = {"root":"_35GRtFssofgM0aohDkssYC","extra-padding":"_2SlSxO5ZBBxLnJ0UaiM7WX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/card-content.scss
// module id = 1184
// module chunks = 0